import {Icon} from '@chakra-ui/react';

export const EgalimIcon: React.FC<{
  color?: string;
  width?: string;
  height?: string;
}> = ({color = 'white', width = '21px', height = '20px'}) => {
  return (
    <Icon
      width={width}
      height={height}
      viewBox='0 0 18 16'
      fill={color}
      xmlns='http://www.w3.org/2000/svg'
    >
      <path d='M9.5625 2.28802C6.79922 2.28802 4.46133 4.12699 3.6668 6.66228C4.84805 6.05524 6.18047 5.71601 7.59375 5.71601H10.6875C10.9969 5.71601 11.25 5.97311 11.25 6.28735C11.25 6.60158 10.9969 6.85868 10.6875 6.85868H10.125H7.59375C7.01016 6.85868 6.44414 6.92652 5.8957 7.0515C4.98516 7.26218 4.14141 7.63712 3.38555 8.14775C1.34648 9.52966 0 11.89 0 14.5717V15.143C0 15.6179 0.376172 16 0.84375 16C1.31133 16 1.6875 15.6179 1.6875 15.143V14.5717C1.6875 12.8327 2.41523 11.2687 3.57891 10.1724C4.275 12.8684 6.69023 14.8573 9.5625 14.8573H9.59766C14.2418 14.8323 18 10.1831 18 4.45194C18 2.93077 17.7363 1.48458 17.2582 0.18123C17.1668 -0.0651577 16.8117 -0.0544451 16.6887 0.177659C16.0277 1.43459 14.7199 2.28802 13.2188 2.28802H9.5625Z' />
    </Icon>
  );
};
